import axios from 'axios';
import { handleApiError } from '../global/handleApiError';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const fetchBusinessSolutionNames = async (type:string): Promise<string[]> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/businessSolution/all/${type}`, {
      withCredentials: true,
    });

    return response.data.distributionListsNames;
  } catch (error) {
    throw new Error(handleApiError(error));
  }
};

interface SolutionResponse {
  id: string;
  name: string;
  services: string[];
  applications: string[];
}

export const fetchSolutionDataByName = async (listName: string, csrfToken: string | null): Promise<SolutionResponse | null> => {
  if (!csrfToken) {
    throw new Error("CSRF token not available");
  }
  try {
    const response = await axios.post(
      `${API_BASE_URL}/businessSolution/info`,
      { listName },
      {
        headers: {
          'CSRF-Token': csrfToken,
        },
        withCredentials: true,
      }
    );

    return response.data;
  } catch (error) {
    console.error("API Error fetching solution data:", error);
    return null;
  }
};
